import { render, staticRenderFns } from "./VideoCourse.vue?vue&type=template&id=0b79895f&scoped=true&"
import script from "./VideoCourse.vue?vue&type=script&lang=js&"
export * from "./VideoCourse.vue?vue&type=script&lang=js&"
import style0 from "./VideoCourse.vue?vue&type=style&index=0&id=0b79895f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b79895f",
  null
  
)

export default component.exports